function getListingSourceId(listingId) {
    if (!listingId) {
        return null;
    }

    const triad = listingId.split('.');

    if (triad.length !== 3) {
        return null;
    }

    return triad[0];
}

export default getListingSourceId;
